// API functions that accept an axios instance
export const customFieldsApi = {
    async getFieldDefinitions(api, integrationId, params) {
        const searchParams = new URLSearchParams();
        if (params?.appliesTo)
            searchParams.set("appliesTo", params.appliesTo);
        if (params?.isAiExtractable !== undefined)
            searchParams.set("isAiExtractable", String(params.isAiExtractable));
        const url = `/api/v1/integrations/${integrationId}/custom-fields${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
        const response = await api.get(url);
        if (!response.data.success || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch field definitions");
        }
        return response.data.data;
    },
    async getFieldDefinition(api, integrationId, fieldId) {
        const url = `/api/v1/integrations/${integrationId}/custom-fields/${fieldId}`;
        const response = await api.get(url);
        if (!response.data.success || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch field definition");
        }
        return response.data.data;
    },
    async createFieldDefinition(api, integrationId, fieldData) {
        const url = `/api/v1/integrations/${integrationId}/custom-fields`;
        const response = await api.post(url, fieldData);
        if (!response.data.success || !response.data.data) {
            throw new Error(response.data.message || "Failed to create field definition");
        }
        return response.data.data;
    },
    async updateFieldDefinition(api, integrationId, fieldId, fieldData) {
        const url = `/api/v1/integrations/${integrationId}/custom-fields/${fieldId}`;
        const response = await api.put(url, fieldData);
        if (!response.data.success || !response.data.data) {
            throw new Error(response.data.message || "Failed to update field definition");
        }
        return response.data.data;
    },
    async deleteFieldDefinition(api, integrationId, fieldId) {
        const url = `/api/v1/integrations/${integrationId}/custom-fields/${fieldId}`;
        await api.delete(url);
    },
    // Custom Field Values API
    async updateRfqCustomField(api, rfqId, fieldKey, value, customerId) {
        const url = `/api/v1/mail/rfq/${rfqId}/custom-fields/${fieldKey}`;
        const response = await api.put(url, { value, customerId });
        if (!response.data.success) {
            throw new Error(response.data.message || "Failed to update RFQ custom field");
        }
        return response.data.data;
    },
    async updateShipmentCustomField(api, shipmentId, fieldKey, value) {
        const url = `/api/v1/mail/shipment/${shipmentId}/custom-fields/${fieldKey}`;
        const response = await api.put(url, { value });
        if (!response.data.success) {
            throw new Error(response.data.message || "Failed to update shipment custom field");
        }
        return response.data.data;
    },
    async updateRfqCustomFields(api, rfqId, fields, customerId) {
        const url = `/api/v1/mail/rfq/${rfqId}/custom-fields`;
        const response = await api.put(url, { fields, customerId });
        if (!response.data.success) {
            throw new Error(response.data.message || "Failed to update RFQ custom fields");
        }
        return response.data.data;
    },
    async updateShipmentCustomFields(api, shipmentId, fields) {
        const url = `/api/v1/mail/shipment/${shipmentId}/custom-fields`;
        const response = await api.put(url, { fields });
        if (!response.data.success) {
            throw new Error(response.data.message || "Failed to update shipment custom fields");
        }
        return response.data.data;
    },
    async updateContainerCustomField(api, containerId, fieldKey, value) {
        const url = `/api/v1/mail/container/${containerId}/custom-fields/${fieldKey}`;
        const response = await api.put(url, { value });
        if (!response.data.success) {
            throw new Error(response.data.message || "Failed to update container custom field");
        }
        return response.data.data;
    },
    async updateContainerCustomFields(api, containerId, fields) {
        const url = `/api/v1/mail/container/${containerId}/custom-fields`;
        const response = await api.put(url, { fields });
        if (!response.data.success) {
            throw new Error(response.data.message || "Failed to update container custom fields");
        }
        return response.data.data;
    },
    async reorderFieldDefinitions(api, integrationId, appliesTo, fieldOrders) {
        const url = `/api/v1/integrations/${integrationId}/custom-fields/reorder?applies_to=${appliesTo}`;
        const response = await api.put(url, {
            field_orders: fieldOrders.map((item) => ({
                field_key: item.fieldKey,
                field_order: item.fieldOrder,
            })),
        });
        if (!response.data.success) {
            throw new Error(response.data.message || "Failed to reorder field definitions");
        }
        return response.data.data || true;
    },
};
// Field type display names
export const FIELD_TYPE_LABELS = {
    text: "Text",
    number: "Number",
    checkbox: "Checkbox",
    date: "Date",
    datetime: "Date & Time",
};
// Applies to display names
export const APPLIES_TO_LABELS = {
    rfq: "RFQ",
    shipment: "Shipment",
    container: "Container",
};
// Supplied by display names
export const SUPPLIED_BY_LABELS = {
    customer: "Customer",
    user: "User",
};
